import actionTypes from 'Redux/constants';

const initialState = {
  designReviewCounts: {
    reviews_this_month: 0,
    reviews_in_progress: 0,
    reviews_completed: 0,
    reviews_total: 0,
    customer_name: '',
  },
  designReviewHistory: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  reviewCount: { upgrade_to_pro_popup_shown: true },
};

const designReviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_DESIGN_REVIEW_COUNTS:
      return {
        ...state,
        designReviewCounts: action.payload,
      };

    case actionTypes.GET_DESIGN_REVIEW_HISTORY:
      return {
        ...state,
        designReviewHistory: action.payload,
      };

    case actionTypes.SET_REVIEW_COUNT:
      return {
        ...state,
        reviewCount: action.payload,
      };

    default:
      return state;
  }
};

export default designReviewReducer;
